import { useCallback, useMemo } from "react";
import { Outlet, useParams } from "react-router-dom";
import type { DocumentFlowConfig } from "./DocumentFlowContext";
import { DocumentFlowContext } from "./DocumentFlowContext";
import type { TemplateDetail } from "./TemplateCreationContext";
import { useTemplateCreationContext } from "./TemplateCreationContext";
import type { PrescriptionDetail } from "@interfaces";

export function TemplateFlowProvider() {
  const { requestId = "" } = useParams();
  const { addDetail: addTemplateDetail } = useTemplateCreationContext();

  const submitDetail = useCallback(
    async (detail: PrescriptionDetail) => {
      addTemplateDetail(detail as unknown as Omit<TemplateDetail, "localId">);
    },
    [addTemplateDetail],
  );

  const config: DocumentFlowConfig = useMemo(
    () => ({
      routes: {
        searchBackRoute: `/app/solicitudes/${requestId}/plantilla/crear`,
        treatmentRoute: `/app/solicitudes/${requestId}/plantilla/crear/tratamiento`,
        treatmentBackRoute: `/app/solicitudes/${requestId}/plantilla/crear/tratamiento/buscar`,
        afterSubmitRoute: `/app/solicitudes/${requestId}/plantilla/crear`,
      },
      labels: {
        treatmentTitle: "Detalle plantilla",
        submitButtonText: "Agregar a plantilla",
        searchTitle: "Busca el medicamento para tu plantilla",
        mobileSearchTitle: "Agregar a plantilla",
      },
      submitDetail,
      enableInteractions: false,
      showTemplatesSection: false,
    }),
    [requestId, submitDetail],
  );

  return (
    <DocumentFlowContext.Provider value={config}>
      <Outlet />
    </DocumentFlowContext.Provider>
  );
}
